import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { getReportSelections, report } from '../../../services/api';
import Grounds from 'ThreeTerminal_base/grounds';

const Selections = function Selections({ content, showSuccess }) {
    const [selectItems, setSelectItems] = useState([{ _id: 'other', title: '其他' }]);
    const [activeItems, setActiveItems] = useState({});
    const [otherContent, setOtherContent] = useState('');
    const [showTips, setShowTips] = useState(false);

    useEffect(() => {
        getReportSelections(content.reportType).then(data => {
            setSelectItems(data.concat(selectItems));
        });
    }, []);

    const updateActiveItems = function updateActiveItems(item) {
        let newItems = Object.assign({}, activeItems);

        if (activeItems[item._id]) {
            delete newItems[item._id];
            if (item._id === 'other') setShowTips(false);
        } else {
            newItems[item._id] = item;
        }

        setActiveItems(newItems);
    };

    const updateOtherContent = function updateOtherContent(value) {
        if (value) setShowTips(false);
        setOtherContent(value);
    };

    const submit = async function submit() {
        if ((activeItems['other'] && !otherContent) || !Object.keys(activeItems).length) {
            setShowTips(true);
        } else {
            if (otherContent) {
                activeItems['other'] = { content: otherContent };
            }
            await report({ type: content.reportType, data: activeItems });
            showSuccess(3);
        }
    };

    return (
        <div className={styles.selections}>
            {selectItems.map(item => {
                return (
                    <div
                        key={item._id}
                        onClick={() => updateActiveItems(item)}
                        className={`${styles.select_item} ${activeItems[item._id] ? styles.select_item_active : null}`}>
                        <div className={styles.circle} />
                        <div className={styles.item_title}>{item.title}</div>
                    </div>
                );
            })}
            <textarea
                className={styles.other_content}
                onChange={e => updateOtherContent(e.target.value)}
                placeholder="请输入您想举报的内容"
                onBlur={() => window.scroll(0, 0)}
            />
            {showTips ? <div className={styles.tips}>请填写想举报的内容</div> : null}
            <div className={styles.btn} onClick={() => submit()}>
                提交
            </div>
        </div>
    );
};

Selections.propTypes = {
    content: PropTypes.object,
    showSuccess: PropTypes.number,
};

class Layout extends React.PureComponent {
    state = {
        successTip: 0,
    };

    static propTypes = {
        content: PropTypes.object,
    };

    showSuccess = second => {
        this.setState(
            {
                successTip: second,
            },
            () => {
                if (this.state.successTip > 0) {
                    setTimeout(() => {
                        this.showSuccess(this.state.successTip - 1);
                    }, 1000);
                } else {
                    Grounds.close();
                }
            },
        );
    };

    successTip = () => {
        if (this.state.successTip) {
            return (
                <div className={styles.successTip}>
                    <div>
                        <div>举报成功</div>
                        <div>{this.state.successTip}秒后退出</div>
                    </div>
                </div>
            );
        }

        return null;
    };

    render() {
        const { content } = this.props;
        const winterOlympicsCopyright = content.winterOlympicsCopyright;

        return (
            <div className={styles.container}>
                {this.successTip()}
                <div className={styles.title}>
                    选择举报原因
                    {winterOlympicsCopyright.winterOlympicsSwitch === '1' && (
                            <a
                                className={styles.winterOlympicsCopyright}
                                href={winterOlympicsCopyright.winterOlympicsUrl}>
                                <img src={winterOlympicsCopyright.winterOlympicsPic} />
                            </a>
                        )}
                </div>
                <Selections content={this.props.content} showSuccess={this.showSuccess} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
